import { ApolloError } from "@apollo/client"

const GENERIC_ERROR = "Oops! Something went wrong."

export function getApolloErrorExplanation(error: Pick<ApolloError, "message"> | null | undefined) {
  if (!error) {
    return GENERIC_ERROR
  }

  if (error.message.includes("429")) {
    return "You made too many requests. Try closing other tabs with the app and then try again after a short while."
  }

  return GENERIC_ERROR
}
